import { useEffect, useLayoutEffect, useState } from "react";
import WorldMpProvider from "@/core/data-provider/data-mp/world/world-mp-provider";
import dateTimeFromUnix from "@/core/helpers/dateTimeFromUnix";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";

export default function useGetRefreshableServerDateAndTime(isOpen: boolean, activeId: number) {
  const [serverTime, setServerTime] = useState(null);
  const [timeDiff, setTimeDiff] = useState(null);
  const [timeZone, setTimeZone] = useState(null);

  useLayoutEffect(() => {
    const fetchTime = async () => {
      const timeDiffStr = sessionStorage.getItem("timeDiff");
      const storedTimeDiff = timeDiffStr ? Number(timeDiffStr) : null;
      const storedTimeZone = sessionStorage.getItem("timeZone");

      if (storedTimeDiff !== null && storedTimeZone !== null) {
        setTimeDiff(storedTimeDiff);
        setTimeZone(storedTimeZone);
        const currTime = Math.floor(Date.now() / 1000) + storedTimeDiff;
        setServerTime(dateTimeFromUnix(currTime, storedTimeZone));
      } else {
        try {
          const response = await WorldMpProvider.getWorldTime();

          if (response instanceof RpcMpProviderSuccessResponse) {
            const serverData = response.data.server;
            const newTimeDiff = serverData.timestamp - Math.floor(Date.now() / 1000);
            const newTimeZone = serverData.timezone;

            sessionStorage.setItem("timeDiff", newTimeDiff.toString());
            sessionStorage.setItem("timeZone", newTimeZone);

            setTimeDiff(newTimeDiff);
            setTimeZone(newTimeZone);
            setServerTime(dateTimeFromUnix(serverData.timestamp, newTimeZone));
          } else {
            console.error("Failed to fetch useGetServerDateAndTime");
          }
        } catch (e) {
          console.error("Failed to fetch useGetServerDateAndTime:", e);
        }
      }
    };

    fetchTime();
  }, []);

  useEffect(() => {
    if (timeDiff === null || timeZone === null || !isOpen || typeof activeId === "number")
      return () => {};

    const intervalId = setInterval(() => {
      const currTime = Math.floor(Date.now() / 1000) + timeDiff;
      setServerTime(dateTimeFromUnix(currTime, timeZone));
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeDiff, timeZone, isOpen, activeId]);

  return serverTime;
}
